export default "__VITE_ASSET__CkOB7LF6__"